__turbopack_context__.v({
  "className": "montserrat_3a58b2f8-module__9cXDsq__className",
});
